var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavAiArtifacts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 3,
  y: 14,
  width: 7,
  height: 7,
  rx: 1
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 17.5,
  cy: 17.5,
  r: 3.5
})));
SvgNavAiArtifacts.displayName = "SvgNavAiArtifacts";
export { SvgNavAiArtifacts as ReactComponent };
export default SvgNavAiArtifacts;